{
  "#SALES_STATISTICS": {
    "TITLE": "Sales Statistics",
    "MODULE_TITLE": "Sales Statistics",
    "DASHBOARD": "Dashboard",
    "TABLE": "Table",
    "MENU": {
      "DASHBOARD": "Dashboard",
      "TABLE": "Table"
    },
    "FILTER": {
      "TITLE": "Filter",
      "MATCH_LABEL": "Values from period",
      "MATCH": {
        "OR": "In either period",
        "CURRENT": "Only in current period",
        "PREVIOUS": "Only in comparison period"
      },
      "EXTRA_TITLE": "More Filters",
      "SEARCH": "Search...",
      "NO_RESULTS": "No results",
      "NO_SELECTED": "No selection",
      "SELECT_ALL": "Select all",
      "DESELECT_ALL": "Deselect all",
      "RESET": "Reset",
      "RESET_NAMED": "Reset filter {{label}}",
      "LOAD_ERROR": "Error",
      "EMPTY": "Empty",
      "RELOAD": "Reload filters",
      "LOADING": "Loading data...",
      "TAB_ALL": "All",
      "TAB_SELECTED": "Selected",
      "NO_NAME": "(No name)",
      "APPLY": "Apply",
      "BACK": "Back",
      "CLEAR_SELECTION": "Clear selection",
      "LOAD_MORE": "Load more...",
      "SALES_ORGS": "Sales Organisations",
      "PRODUCT_GROUPS": "Product Groups",
      "MAIN_GROUPS": "Main Groups",
      "WAREHOUSES": "Warehouses",
      "DISTRIBUTION_CHANNELS": "Distribution Channels",
      "SUB_GROUPS": "Sub Groups",
      "SUB_SUB_GROUPS": "Sub Sub Groups",
      "PRODUCTS": "Products",
      "CUSTOMER_GROUPS": "Customer Groups",
      "CUSTOMERS": "Customers",
      "SALES_REPRESENTATIVES": "Sales Representatives",
      "OLD_STATISTIC_TYPES": "Statistic Types (old)",
      "CONDITION_GROUPS": "Condition Groups",
      "VEHICLE_GROUPS": "Vehicle Groups",
      "VEHICLES": "Vehicles",
      "GROUP": {
        "CROSS": "General",
        "PRODUCT": "Product Level",
        "BELEG": "Document Level"
      },
      "SORT": {
        "GROUPED": "Grouped",
        "UNGROUPED": "Flat"
      },
      "EDIT": {
        "START": "Edit",
        "DONE": "Done",
        "DRAG": "Reorder"
      }
    },
    "DOCUMENT_TYPE": {
      "TITLE": "Document Type",
      "SELECT": "Select document type"
    },
    "STATISTIC_TYPE": {
      "TITLE": "Statistic Type",
      "PLACEHOLDER": "Statistic type",
      "TOTAL": "Total",
      "INTERNAL": "Internal",
      "TOTAL_WITH_INTERNAL": "Total + Internal"
    },
    "ACTIONS": {
      "TITLE": "Actions",
      "LOAD_TEMPLATE": "Load template",
      "SAVE_TEMPLATE": "Save template"
    },
    "TEMPLATES": {
      "TITLE": "Templates",
      "PLACEHOLDER": "Select template",
      "NONE": "No template selected",
      "SAVE": "Save",
      "NEW": "New template",
      "EDIT": "Edit",
      "EDIT_DONE": "Finish editing",
      "RENAME": "Rename",
      "DELETE": "Delete",
      "UNSAVED": "Not saved",
      "LAST_SAVED": "Last saved"
    },
    "CHART": {
      "CHANGE": "Change",
      "SINGLE_SALES_ORG": "Sales Organisation",
      "SALES_ORGS": "Sales Organisations",
      "SALES_ORGS_SUBTITLE": "Revenue per sales organisation",
      "SALES_ORGS_SUBTITLE_DB": "CM per sales organisation",
      "SALES_ORGS_SUBTITLE_DB_PERCENT": "CM% per sales organisation",
      "SALES_ORGS_SUBTITLE_INVENTORY": "Inventory value per sales organisation",
      "PRODUCT_GROUPS": "Product Groups",
      "MAIN_GROUPS": "Main Groups",
      "SUB_GROUPS": "Sub Groups",
      "SUB_SUB_GROUPS": "Sub-Sub Groups",
      "PRODUCTS": "Products",
      "CUSTOMER_GROUPS": "Customer Groups",
      "CUSTOMERS": "Customers",
      "SALES_REPRESENTATIVES": "Sales Representatives",
      "DRILL_UP": "Back",
      "VIEW_PREV": "One level up",
      "VIEW_NEXT": "One level down",
      "SALES_TREND": "Revenue Trend",
      "DB_TREND": "CM Trend",
      "DB_PERCENT_TREND": "CM% Trend",
      "INVENTORY_TREND": "Inventory Value Trend",
      "SALES_FOR": "Revenue for",
      "DB_FOR": "CM for",
      "DB_PERCENT_FOR": "CM% for",
      "INVENTORY_FOR": "Inventory value for",
      "TOP_15_SALES_FOR": "Top 15 revenue for",
      "TOP_15_INVENTORY_FOR": "Top 15 inventory value for",
      "TOP_15_DB_FOR": "Top 15 CM for",
      "TOP_15_DB_PERCENT_FOR": "Top 15 CM% for",
      "WAREHOUSE_INVENTORY": "Warehouse",
      "WAREHOUSE_INVENTORY_FOR": "Inventory value by warehouse for",
      "ALL_SALES_ORGS": "all sales organisations",
      "ALL_WAREHOUSES": "all warehouses",
      "FOR": "for",
      "PRODUCT_GROUP": "Product Group",
      "ALL_PRODUCT_GROUPS": "all product groups",
      "AND": "and",
      "AMOUNT_IN_EUR": "Amount in €",
      "PERCENT": "Share in %",
      "SHOW_AS_BAR": "Show as bar chart",
      "SHOW_AS_DONUT": "Show as donut chart"
    },
    "SERIES": {
      "NET": "Net",
      "WES": "COGS",
      "DB": "CM",
      "SALES": "Revenue",
      "DB_PERCENT": "CM%",
      "SALES_POSITIVE": "Revenue growth",
      "SALES_NEGATIVE": "Revenue decline",
      "DB_POSITIVE": "CM growth",
      "DB_NEGATIVE": "CM decline",
      "DB_PERCENT_POSITIVE": "CM% growth",
      "DB_PERCENT_NEGATIVE": "CM% decline",
      "INVENTORY_POSITIVE": "Inventory growth",
      "INVENTORY_NEGATIVE": "Inventory decline",
      "REFERENCE": "Comparison"
    },
    "TOTAL": {
      "SALES": "Revenue",
      "CONTRIBUTION_MARGIN": "Contribution Margin",
      "DB_PERCENT": "CM Percent",
      "INVENTORY_VALUE": "Inventory Value",
      "COMPARISON": "Comparison:",
      "ACHIEVED": "achieved"
    },
    "ERROR": {
      "LOAD_FAILED": "Failed to load data"
    },
    "COLUMNS": {
      "SALES_ORG": "Sales Organisation",
      "PRODUCT_GROUP": "Product Group",
      "MAIN_GROUP": "Main Group",
      "SUB_GROUP": "Sub Group",
      "PRODUCT": "Product",
      "CUSTOMER": "Customer",
      "DATE": "Date",
      "NET": "Net",
      "NET_COMPARISON": "Net Change",
      "NET_COMPARISON_VALUE": "Net Comparison",
      "NET_CHANGE_VALUE": "Net Change €",
      "NET_DEVELOPMENT": "Net Development",
      "WES": "COGS",
      "WES_COMPARISON": "COGS Change",
      "WES_COMPARISON_VALUE": "COGS Comparison",
      "WES_CHANGE_VALUE": "COGS Change €",
      "DB": "CM",
      "DB_COMPARISON": "CM Change",
      "DB_COMPARISON_VALUE": "CM Comparison",
      "DB_CHANGE_VALUE": "CM Change €",
      "DB_DEVELOPMENT": "CM Development",
      "DB_PERCENT": "CM%",
      "INVENTORY_VALUE": "Inventory Value",
      "INVENTORY_VALUE_COMPARISON": "Inventory Value Change",
      "INVENTORY_VALUE_COMPARISON_VALUE": "Inventory Value Comparison",
      "INVENTORY_VALUE_CHANGE_VALUE": "Inventory Value Change €",
      "INVENTORY_VALUE_DEVELOPMENT": "Inventory Value Development",
      "ACTIONS": "Actions"
    },
    "NO_DATA": "No data available"
  }
}
